import type { SVGProps } from 'react';

const SvgAssetTypeUnknown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17.66 19.57c-.5 0-.91-.41-.91-.91s.41-.91.91-.91.91.41.91.91-.41.91-.91.91M14 19H6c-1.65 0-3-1.35-3-3V8c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3 0 .55-.45 1-1 1s-1-.45-1-1-.45-1-1-1H6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1 .45 1 1s-.45 1-1 1"
    />
    <path
      fill="currentcolor"
      d="M17.64 17.01c-.25 0-.46-.09-.62-.26a.9.9 0 0 1-.25-.63v-.91c0-.25.08-.46.25-.63s.38-.26.62-.26c.31 0 .59-.05.83-.14s.42-.23.56-.43.21-.47.21-.8c0-.25-.06-.45-.17-.64-.12-.19-.28-.33-.48-.44a1.58 1.58 0 0 0-1.28-.05c-.18.07-.35.17-.49.3-.14.12-.32.22-.52.28-.22.07-.45.02-.68-.15s-.35-.38-.37-.62.07-.47.27-.67c.3-.31.66-.55 1.06-.72.41-.17.84-.26 1.3-.26.58 0 1.1.13 1.57.4.46.26.84.62 1.12 1.07s.42.96.42 1.52c0 .42-.06.79-.19 1.12q-.195.495-.54.84c-.23.23-.51.42-.81.56-.29.13-.6.22-.93.28v.37c0 .25-.08.46-.25.63-.16.17-.37.26-.62.26z"
    />
  </svg>
);
export default SvgAssetTypeUnknown;
